import React, { useState, useEffect } from 'react'
import { MiFooter } from '../../components/footer/MiFooter';
import { ContentBodyCategoriaEmpresa } from '../../components/CategoriasEmpresa/ContentBodyCategoriaEmpresa';
import './CategoriasEmpresa.css'
import HeaderHome from '../../components/headerHome/HeaderHome';

export const CategoriasEmpresa = () => {

  const [MenuLateralAux, setMenuLateralAux] = useState();

  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  }

  return (
    <div className='Presupuestos'>
      <div className='headerPresupuestos'>
        <HeaderHome
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="bodyPresupuestos">
        <ContentBodyCategoriaEmpresa
          MenuLateralAux={MenuLateralAux}
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className='footerPresupuestos'>
        <MiFooter
        />
      </div>
    </div>
  )
}
